import { render, staticRenderFns } from "./groupFitnessDashboardDownloads.vue?vue&type=template&id=4d920af2&scoped=true"
import script from "./groupFitnessDashboardDownloads.vue?vue&type=script&lang=js"
export * from "./groupFitnessDashboardDownloads.vue?vue&type=script&lang=js"
import style0 from "./groupFitnessDashboardDownloads.vue?vue&type=style&index=0&id=4d920af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d920af2",
  null
  
)

export default component.exports